import useSubscriptionStore from "../store/useSubscriptionStore";

/**
 * Tracks the number of free trials used and the limit.
 * @returns {Object} freeTrialsUsed: number, freeTrialLimit: number, getFreeTrialsUsed: function
 */
const useFreeTrials = () => {
    const { 
        freeTrialsRemaining, 
        freeTrialLimit, 
        isFreeTrial, 
        fetchSubscriptionStatus 
    } = useSubscriptionStore();

    return { 
        freeTrialsRemaining, 
        freeTrialLimit, 
        isFreeTrial, 
        getFreeTrialsUsed: fetchSubscriptionStatus 
    };
};

export default useFreeTrials;

